import { QueryBuilderConfig, DataTypeParent, DataTypeChildren, DataTypeBuilder, FilterClientCarrierIdDto } from '../commoncomponent/QueryBuilderAutopass/query-builder/query-builder.interfaces';

export const INVOICE_TYPE: Array<any> = [{
    name: 'Invoice',
    value: 100
  },{
    name: 'Credit Note',
    value: 101
  }];

export interface ValidationFiltersDto {
  ClientCode      : Array<string>,
  ClientDivision  : Array<string>,
  ClientLocation  : Array<string>,
  CarrierScac     : Array<string>,
  CarrierLocation : Array<string>
}

export interface FilterIdsDto{
  FilterIds: Array<any>
}

export const DATA_TYPE_PARENT_VALIDATION: Array<DataTypeParent> = [
  {
    field: 'ValidationRule',
    values: [
      'AppliesTo',
      'Condition'
    ]
  }  
]


export const DATA_TYPE_PARENT: Array<DataTypeParent> = [
    {
      field: 'AccountConfig',
      values: [
        'InvoiceRule',
        'ShipmentRule',
        'AuditRule',
        'DuplicationRule',
        'TMSRule',
        'Condition'
      ]
    },
    {
      field: 'InvoiceRule',
      values: [
        'ValidateGoLiveDate',
        'ValidatePdfProvided',
        'ValidateField',
        'ValidateBalanceCheck',
        'CompareProperties',
        'ValidateGroup',
        'Condition'
      ]
    },
    {
      field: 'ShipmentRule',
      values: [
        'ValidateGoLiveDate',
        'ValidateField',
        'ValidateFieldMultiple',
        'CompareProperties',
        'ValidateGroup',
        'ValidateShipmentDate',
        'Condition'
      ]
    },
    {
      field: 'AuditRule',
      values: [
        'ValidateNoRateResult',
        'ValidateExpiredRate',
        'ValidateOvercharge',
        'ValidateUndercharge',
        'ValidateInvoiceOvercharge',
        'ValidateInvoiceUndercharge',
        'ValidateOverchargeIgnoreUndercharges',
        'ValidateInvoiceOverchargeIgnoreUndercharges',
        'ValidateOverchargeIgnoreNoRates',
        'OverrideVariance',
        'Condition'
      ]
    },
    {
      field: 'DuplicationRule',
      values: [
        'ValidateInvoiceNo',
        'ValidateSid',
        'Condition'
      ]
    },
    {
      field: 'TMSRule',
      values: [
        'ValidateNoTmsMatch',
        'ValidateTmsMatchCost',
        'ValidateTmsCarrier',
        'ValidateNoTmsValueMatch',
        'ValidateCompareTmsValue',
        'ValidateTmsValueIfExists',
        'ValidateTmsValueMandatory',
        'ValidatePoMatch',
        'ValidateOvercharge',
        'ValidateUndercharge',
        'ValidateInvoiceOvercharge',
        'ValidateInvoiceUndercharge',
        'OverrideVariance',
        'Condition'
      ]
    }
]

export const DATA_TYPE_CHILDREN_VALIDATION: Array<DataTypeChildren> = [
  {
    field: 'ValidationRule',
    values: [
      'Status',
      'Level',
      'AllowPass',
      'FailureField',
      'FailureMessage'
    ]
  },  
  {
    field: 'Condition',
    values: [
      'As Is'
    ]
  },
  {
    field: 'AppliesTo',
    values: ['']
  }
];

export const DATA_TYPE_CHILDREN: Array<DataTypeChildren> = [
  {
    field: 'AccountConfig',
    values: [
      'Status',
      'Currency',
      'OverchargeAmount',
      'OverchargeType',
      'UnderchargeAmount',
      'UnderchargeType',
      'RunAudit',
      'RunTmsMatch',
      'SaveTmsMatchData',
      'AddToleranceSavings',
      'RunPoMatch',
      'InvoiceSource',
      'SidDuplicationType'
    ]
  },
  {
    field:'InvoiceRule',
    values: [
      'Priority',
      'ResultAction',
      'ReasonCode',
      'ActionCommentsTemplate',
      'WebResAllocation'
    ]
  },
  {
    field: 'ShipmentRule',
    values: [
      'Priority',
      'ResultAction',
      'ReasonCode',
      'ActionCommentsTemplate',
      'WebResAllocation'
    ]
  },
  {
    field: 'AuditRule',
    values: [
      'Priority',
      'ResultAction',
      'ReasonCode',
      'ActionCommentsTemplate',
      'WebResAllocation'
    ]
  },
  {
    field: 'DuplicationRule',
    values: [
      'Priority',
      'ResultAction',
      'ReasonCode',
      'ActionCommentsTemplate',
      'WebResAllocation'
    ]
  },
  {
    field: 'TMSRule',
    values: [
      'Priority',
      'ResultAction',
      'ReasonCode',
      'ActionCommentsTemplate',
      'WebResAllocation'
    ]
  },
  {
    field: 'ValidateGoLiveDate',
    values: []
  },
  {
    field: 'ValidatePdfProvided',
    values: [
      'PdfDocumentType'
    ]
  },
  {
    field: 'ValidateField',
    values: [
      'Property',
      'PropertyType',
      'Operator',
      'Value'
    ]
  },
  {
    field: 'ValidateBalanceCheck',
    values: []
  },
  {
    field: 'CompareProperties',
    values: [
      'Property',
      'PropertyType',
      'Operator',
      'Property2',
      'PropertyType2',
      'AdjustValue'
    ]
  },
  {
    field: 'ValidateGroup',
    values: [
      'GroupType',
      'GroupOperator'
    ]
  },
  {
    field: 'ValidateFieldMultiple',
    values: [
      'Property',
      'PropertyType',
      'Operator',
      'Value'
    ]
  },
  {
    field: 'ValidateShipmentDate',
    values: [
      'IntervalDays'
    ]
  },
  {
    field: 'ValidateNoRateResult',
    values: []
  },
  {
    field: 'ValidateExpiredRate',
    values: []
  },
  {
    field: 'ValidateOvercharge',
    values: [
      'ValidateMissingAccessorial',
      'MaxValue',
      'MaxValueVarianceType'
    ]
  },
  {
    field: 'ValidateUndercharge',
    values: [
      'ValidateMissingAccessorial',
      'MaxValue',
      'MaxValueVarianceType'
    ]
  },
  {
    field: 'ValidateInvoiceOvercharge',
    values: [
      'ValidateMissingAccessorial',
      'MaxValue',
      'MaxValueVarianceType'
    ]
  },
  {
    field: 'ValidateInvoiceUndercharge',
    values: [
      'ValidateMissingAccessorial',
      'MaxValue',
      'MaxValueVarianceType'
    ]
  },
  {
    field: 'ValidateOverchargeIgnoreUndercharges',
    values: [
      'ValidateMissingAccessorial',
      'MaxValue',
      'MaxValueVarianceType'
    ]
  },
  {
    field: 'ValidateInvoiceOverchargeIgnoreUndercharges',
    values: [
      'ValidateMissingAccessorial',
      'MaxValue',
      'MaxValueVarianceType'
    ]
  },  
  {
    field: 'ValidateOverchargeIgnoreNoRates',
    values: [
      'ValidateMissingAccessorial',
      'MaxValue',
      'MaxValueVarianceType'
    ]
  },  
  {
    field: 'OverrideVariance',
    values: [
      'OverrideOverchargeAmount',
      'OverrideOverchargeVarianceType',
      'OverrideUnderchargeAmount',
      'OverrideUnderchargeVarianceType'
    ]
  },
  {
    field: 'ValidateInvoiceNo',
    values: [
      'InvoiceStatusValidateList',
      'ValidateInvoiceAmount'
    ]
  },
  {
    field: 'ValidateSid',
    values: [
      'OnlyShipmentWithValue',
      'IgnoreIfUniqueAccessorial',
      'SidIgnoreList',
      'InvoiceStatusValidateList',
      'AccessorialsToAllow'
    ]
  },
  {
    field: 'ValidateNoTmsMatch',
    values: [
      'IgnoreVat',
      'CtmsServiceName'
    ]
  },
  {
    field: 'ValidateTmsMatchCost',
    values: []
  },
  {
    field: 'ValidateTmsCarrier',
    values: []
  },
  {
    field: 'ValidateNoTmsValueMatch',
    values: [
      'Property',
      'PropertyType'
    ]
  },
  {
    field: 'ValidateCompareTmsValue',
    values: [
      'Property',
      'PropertyType',
      'Operator'
    ]
  },
  {
    field: 'ValidateTmsValueIfExists',
    values: [
      'Property',
      'PropertyType',
      'Operator',
      'Value'
    ]
  },
  {
    field: 'ValidateTmsValueMandatory',
    values: [
      'Property',
      'PropertyType',
      'Operator',
      'Value'
    ]
  },
  {
    field: 'ValidatePoMatch',
    values: []
  },
  {
    field: 'Condition',
    values: [
      'As Is'
    ]
  }
];

export const QUERYBUILDER_PROPERTIES_VALIDATION: QueryBuilderConfig =  {
  conditionQueryBuilderConfig:{
    entities: {
      clientProfile         : {name: 'Client Profile'},
      carrierProfile        : {name: 'Carrier Profile'},
      clientCarrierProfile  : {name: 'Client Carrier Profile'},
      invoiceProfile        : {name: 'Invoice'},
      shipmentProfile       : {name: 'Shipment'},
      uomProfile            : {name: 'Uoms'},
      chargeProfile         : {name: 'Invoice Charges'},
      invoiceIdProfile      : {name: 'Invoice IDs'},
      clientFieldProfile    : {name: 'Client Fields'},
      sidProfile            : {name: 'Shipment Ids'}
    },
    fields: { }
  },

  fields: {
    status: {
      name: 'status', 
      type: 'category', 
      operators: ['='],
      options:[
        { name: 'Active',value: 'Active'},
        { name: 'Disabled',value: 'Disabled'}
      ]
    },

    level: {
      name: 'level', 
      type: 'category', 
      operators: ['='],
      options:[
        { name: 'Invoice',value: 'Invoice'},
        { name: 'Shipment',value: 'Shipment'}
      ]
    },

    allowpass: {
      name: 'allowpass', 
      operators: ['='], 
      type: 'boolean'
    },

    failurefield: {
      name: 'failurefield', 
      operators: ['='], 
      type: 'string'
    },

    failuremessage: {
      name: 'failuremessage', 
      operators: ['='], 
      type: 'string'
    }
  }
}


export const QUERYBUILDER_PROPERTIES: QueryBuilderConfig =  {
  conditionQueryBuilderConfig:{
    entities: {
      clientProfile: {name: 'Client Profile'},
      carrierProfile: {name: 'Carrier Profile'},
      clientCarrierProfile: {name: 'Client Carrier Profile'},
      invoiceProfile: {name: 'Invoice'},
      shipmentProfile: {name: 'Shipment'},
      uomProfile: {name: 'Uoms'},
      chargeProfile: {name: 'Invoice Charges'},
      invoiceIdProfile: {name: 'Invoice IDs'},
      clientFieldProfile: {name: 'Client Fields'},
      sidProfile: {name: 'Shipment Ids'}
    },
    fields: { }
  },

  fields: {
    // Status
    status: {
      name: 'Status', 
      operators: ['='], 
      type: 'category', 
      options: [
        { name: 'Active',value: 'Active'},
        { name: 'Disabled',value: 'Disabled'},
        { name: 'Testing',value: 'Testing'}
      ]
    },

    // Currency
    currency: {
      name: 'Currency', 
      type: 'currency', 
      operators: ['=']
    },

    // OverchargeAmount
    overchargeamount: {
      name: 'OverchargeAmount', 
      type: 'number'
    },

    // OverchargeType
    overchargetype: {
      name: 'OverchargeType', 
      type: 'category',
      options:[
        { name: 'Value',value: 'Value'},
        { name: 'Percentage',value: 'Percentage'}
      ]
    },
    
    // UnderchargeAmount
    underchargeamount: {
      name: 'UnderchargeAmount', 
      type: 'number'
    },

    // UnderchargeType
    underchargetype: {name: 'UnderchargeType', type: 'category',
      options:[
        { name: 'Value',value: 'Value'},
        { name: 'Percentage',value: 'Percentage'}
      ]
    },
    // Run Audit
    runaudit: {
      name: 'RunAudit', 
      type: 'boolean'
    },

    // RunTmsMatch
    runtmsmatch: {
      name: 'RunTmsMatch', 
      type: 'boolean'
    },

    // SaveTmsMatchData
    savetmsmatchdata: {
      name: 'SaveTmsMatchData', 
      type: 'boolean'
    },

    // AddToleranceSavings
    addtolerancesavings: {
      name: 'AddToleranceSavings', 
      type: 'boolean'
    },

    // RunPoMatch
    runpomatch: {
      name: 'RunPoMatch', 
      type: 'boolean'
    },

    // InvoiceSource
    invoicesource: { 
      name: 'InvoiceSource', 
      type: 'invoicesource', 
      operators: ['='],
      options: [
        { name: 'EDI',value: '110'},
        { name: 'OCR',value: '102'},
        { name: 'On Hold',value: '119'},
      ]
    },
    
    // SidDuplicationType
    sidduplicationtype: { 
      name: 'SidDuplicationType', 
      type: 'category', 
      options: [
        { name: 'Client',value: '100'},
        { name: 'Carrier',value: '101'},
        { name: 'ClientAndCarrier',value: '102'},
        { name: 'ClientOrCarrier',value: '103'}
      ]
    },

    // Priority
    priority: {
      name: 'Priority', 
      type: 'number'
    },

    // ResultAction
    resultaction: {
      name: 'ResultAction', 
      type: 'category', 
      options: [
        { name: 'None',value: 'None'},
        { name: 'SendToWeb',value: 'SendToWeb'},
        { name: 'Reject',value: 'Reject'},
        { name: 'Fail',value: 'Fail'},
        { name: 'Error',value: 'Error'},
        { name: 'OnHold',value: 'OnHold'}
      ]
    },

    // ReasonCode
    reasoncode: {
      name: 'ReasonCode', 
      type: 'reasoncode', 
      operators: ['=','!=']
    },

    // ActionCommentsTemplate
    actioncommentstemplate: {
      name: 'ActionCommentsTemplate', 
      type: 'textarea', 
      operators: ['=', '!=']
    },

    grouptype: {
      name: 'GroupType',
      type: 'category',
      options: [
        { name: 'CLIENTFIELD', value: 'CLIENTFIELD'},
        { name: 'INVOICESID', value: 'INVOICESID'},
        { name: 'ACCESSORIAL', value: 'ACCESSORIAL'},
        { name: 'INVOICEID', value: 'INVOICEID'},
        { name: 'UOM', value: 'UOM'},
        { name: 'ADDITIONALDATA', value: 'ADDITIONALDATA'}
      ]
    },

    groupoperator: {
      name: 'GroupOperator',
      type: 'category',
      options: [
        { name: 'IsEmpty', value: 'IsEmpty'},
        { name: 'IsNotEmpty', value: 'IsNotEmpty'}
      ]
    },

    webresallocation: {
      name: 'WebResAllocation', 
      type: 'category',
      options:[
        { name: 'Client',value: 'Client'},
        { name: 'Carrier',value: 'Carrier'},
        { name: 'Both',value: 'Both'},
      ]
    },

    pdfdocumenttype: {
      name: 'PDFDocumentType', 
      type: 'string'
    },

    property: {
      name: 'Property', 
      type: 'string'
    },

    property2: {
      name: 'Property2', 
      type: 'string'
    },

    propertytype: {
      name: 'PropertyType', 
      type: 'string'
    },

    propertytype2: {
      name: 'PropertyType2', 
      type: 'string'
    },

    adjustvalue: {
      name: 'AdjustValue', 
      type: 'number'
    },

    operator: {
      name: 'Operator', 
      type: 'category',
      options:[
        { name: 'None',value: 'None'},
        { name: 'IsEqual',value: 'IsEqual'},
        { name: 'IsNotEqual',value: 'IsNotEqual'},
        { name: 'IsGreaterThan',value: 'IsGreaterThan'},
        { name: 'IsGreaterThanOrEqual',value: 'IsGreaterThanOrEqual'},
        { name: 'IsLessThan',value: 'IsLessThan'},
        { name: 'IsLessThanOrEqual',value: 'IsLessThanOrEqual'},
        { name: 'Exists',value: 'Exists'},
        { name: 'NotExists',value: 'NotExists'},
        { name: 'ListContains',value: 'ListContains'},
        { name: 'NotListContains',value: 'NotListContains'},
        { name: 'StartsWith',value: 'StartsWith'},
        { name: 'NotStartsWith',value: 'NotStartsWith'},
        { name: 'EndsWidth',value: 'EndsWidth'},
        { name: 'NotEndsWidth',value: 'NotEndsWidth'},
        { name: 'ListStartsWith',value: 'ListStartsWith'},
        { name: 'NotListStartsWith',value: 'NotListStartsWith'},
        { name: 'RegexMatch',value: 'RegexMatch'},
        { name: 'NotRegexMatch',value: 'NotRegexMatch'},
        { name: 'Contains',value: 'Contains'},
        { name: 'NotContains',value: 'NotContains'},
      ]
    },

    value: {
      name: 'Value', 
      type: 'string'
    },

    overrideoverchargeamount: { 
      name: 'OverrideOverchargeAmount', 
      type: 'number' 
    },

    overrideoverchargevariancetype: { 
      name: 'OverrideOverchargeVarianceType', 
      type: 'category',
        options:[
          { name: 'Value',value: 'Value'},
          { name: 'Percentage',value: 'Percentage'}
        ]
    },

    overrideunderchargeamount: { 
      name: 'OverrideUnderchargeAmount', 
      type: 'number' 
    },

    overrideunderchargevariancetype: { 
      name: 'OverrideUnderchargeVarianceType', 
      type: 'category',
      options:[
        { name: 'Value',value: 'Value'},
        { name: 'Percentage',value: 'Percentage'}
      ]
    },

    validatemissingaccessorial: { 
      name: 'ValidateMissingAccessorial', 
      type: 'boolean' 
    },

    maxvalue: { 
      name: 'MaxValue', 
      type: 'number'
    },

    maxvaluevariancetype: { 
      name: 'MaxValueVarianceType', 
      type: 'category',
      options:[
        { name: 'Value',value: 'Value'},
        { name: 'Percentage',value: 'Percentage'}
      ]
    },

    onlyshipmentwithvalue: { 
      name: 'OnlyShipmentWithValue', 
      type: 'boolean'
    },

    ignoreifuniqueaccessorial: { 
      name: 'IgnoreIfUniqueAccessorial', 
      type: 'boolean' 
    },

    sidignorelist: { 
      name: 'SidIgnoreList', 
      type: 'string'
    },

    invoicestatusvalidatelist: { 
      name: 'InvoiceStatusValidateList', 
      operators: ['='], 
      type: 'multiple-custom-invoice-status',
      options:[
        { name: 'OCR',                        value: '102'},
        { name: 'PassedAwaitingProduction',   value: '103'},
        { name: 'RejectedAwaitingProduction', value: '104'},
        { name: 'Failed',                     value: '105'},
        { name: 'WebResolution',              value: '106'},
        { name: 'WebReplies',                 value: '107'},
        { name: 'AfterProductionPassed',      value: '108'},
        { name: 'Closed',                     value: '109'},
        { name: 'EDI',                        value: '110'},
        { name: 'AfterProductionRejected',    value: '112'},
        { name: 'IBMAccountsPayable',         value: '113'},
        { name: 'IBMAccountsPayableReceived', value: '114'},
        { name: 'IBMAwaitingAccountsPayable', value: '115'},
        { name: 'SelfBilling',                value: '116'},
        { name: 'OCRValidation',              value: '117'},
        { name: 'AwaitingOCRData',            value: '118'},
        { name: 'OnHold',                     value: '119'}
      ]
    },

    accessorialstoallow: { 
      name: 'AccessorialsToAllow', 
      type: 'string'
    },

    validateinvoiceamount: { 
      name: 'ValidateInvoiceAmount', 
      type: 'boolean'
    },

    ignorevat: { 
      name: 'IgnoreVat', 
      type: 'boolean' 
    },

    ctmsservicename: { 
      name: 'CtmsServiceName', 
      type: 'string' 
    },

    intervaldays: { 
      name: 'IntervalDays', 
      type: 'number'
    },
  }
}


export const headerStyle: any = {
  'position': 'relative',
  'vertical-align': 'bottom',
  'cursor': 'default',
  'background': '#113e6b',
  'color': '#fff',
  'font-weight': 'bold',
  'font-family': 'Arial',
  'padding': '14px 7px'
}
